import { render, staticRenderFns } from "./Network.vue?vue&type=template&id=32656930&scoped=true&"
import script from "./Network.vue?vue&type=script&lang=ts&"
export * from "./Network.vue?vue&type=script&lang=ts&"
import style0 from "./Network.vue?vue&type=style&index=0&id=32656930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32656930",
  null
  
)

export default component.exports